module.exports = __webpack_public_path__ + "assets/img/Cluey-Learning-2-Landing-Page-+-Website.3315f717.webp";